import React from 'react';
import { BannerProps, money } from './BannerProps';

const paper: React.CSSProperties = {
  background: '#fff',
  color: '#111',
  fontFamily: 'Helvetica, Arial, sans-serif',
  borderRadius: 6,
  padding: '12px 14px',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

/**
 * Design 5: three across. Three services side by side when you want
 * choice, not one offer. Owner-approved mockup #05. Only the first three
 * rows are shown — this design is a shelf, not a full list.
 */
const ThreeUpBanner: React.FC<BannerProps> = ({ promotion, brandColor = '#1e5aa8' }) => {
  const cards = promotion.rows.slice(0, 3);
  return (
    <div style={paper}>
      <p style={{ fontSize: 11, letterSpacing: '0.12em', color: brandColor, fontWeight: 700, margin: '0 0 8px', textTransform: 'uppercase' }}>
        {promotion.headline ?? promotion.name}
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(96px, 1fr))', gap: 8 }}>
        {cards.map((row, i) => (
          <div key={`${row.label}-${i}`} style={{ border: '1px solid #e6eaef', borderRadius: 4, padding: 8, textAlign: 'center', minWidth: 0 }}>
            <div style={{ fontSize: 10.5, overflowWrap: 'break-word' }}>{row.label}</div>
            <div style={{ fontSize: 13, fontWeight: 700, marginTop: 4 }}>{money(row.priceCents)}</div>
            {row.wasCents !== null && (
              <div style={{ fontSize: 9, color: '#15803d', fontWeight: 700, marginTop: 2 }}>
                was {money(row.wasCents)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThreeUpBanner;
